import { uploadedFileName } from '@zealot/shared/utils/mediaFileName';
import React from 'react';

export const isGifUrl = (text) => /^https?:\/\/media\d*\.giphy\.com\//i.test(text?.trim());

export const IMAGE_EXTENSIONS = /\.(jpg|jpeg|png|gif|webp|svg|bmp|heic)(\?|$)/i;

export const URL_SPLIT_REGEX = /(https?:\/\/[^\s<>"{}|\\^`[\]]{4,})/gi;

export const URL_REGEX = /https?:\/\/[^\s<>"{}|\\^`[\]]{4,}/i;

export const hasUrl = (text) => !isGifUrl(text) && !isCloudFrontUrl(text) && URL_REGEX.test(text?.trim());

export const extractFirstUrl = (text) => text?.match(/https?:\/\/[^\s<>"{}|\\^`[\]]{4,}/i)?.[0] ?? null;

export const isCloudFrontUrl = (text) => !!text && text.includes('dupwq54o68dyw.cloudfront.net');

export const isCloudFrontImage = (text) => isCloudFrontUrl(text) && IMAGE_EXTENSIONS.test(text);

export const isCloudFrontFile = (text) => isCloudFrontUrl(text) && !IMAGE_EXTENSIONS.test(text);

export const isMediaMessage = (text) => isGifUrl(text) || isCloudFrontImage(text);

export const getThreadReplies = (messages, parentMessage) => {
  if (!parentMessage) return [];
  return messages.filter((m) => m.replyTo?.serial === parentMessage.serial);
};

export const getThreadMessages = (messages, parentMessage) => {
  if (!parentMessage) return [];
  return [parentMessage, ...getThreadReplies(messages, parentMessage)];
};

export const getFileName = (url) => {
  try {
    return uploadedFileName(new URL(url));
  } catch {
    return 'File';
  }
};

export const renderMessageText = (text) => {
  if (!text) return null;
  const parts = text.split(URL_SPLIT_REGEX);
  return parts.map((part, i) =>
    /^https?:\/\//i.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-500 underline decoration-blue-300 break-all hover:text-blue-600"
        onClick={(e) => e.stopPropagation()}
      >
        {part}
      </a>
    ) : (
      <span key={i}>{part}</span>
    ),
  );
};
